<template>
  <WdsText>{{ employerName }}</WdsText>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'

const EmploymentAssignmentCompanyColumn = graphql(`
  fragment EmploymentAssignmentCompanyColumn on Employment {
    id
    hires {
      data {
        id
        company {
          id
          name
        }
      }
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof EmploymentAssignmentCompanyColumn> }>()
const column = computed(() => useFragment(EmploymentAssignmentCompanyColumn, props.row))

const employerName = computed(() => {
  const { hires } = column.value
  if (hires && hires.data.length > 0 && hires.data[0].company) {
    return hires.data[0].company.name
  }
  return 'Unknown'
})
</script>
